import { Checkbox as MuiCheckbox, CheckboxProps, useTheme } from '@mui/material';
import { ReactNode } from 'react';

interface IProps extends CheckboxProps {
    label?: string | ReactNode;
    disableRipple?: boolean;
    className?: string;
    labelClassName?: string;
    error?: boolean;
    uncheckedStrokeColor?: string;
    testId?: string;
}

export const Checkbox = ({ label, disableRipple = true, className, labelClassName, error, uncheckedStrokeColor = 'black', testId = 'checkbox', ...props }: IProps) => {
    const theme = useTheme();

    return (
        <div data-testid={`${testId}-wrapper`} className={`flex items-center gap-1.5 lg:gap-2.5 ${className}`}>
            <MuiCheckbox
                data-testid={`${testId}-interactable`}
                disableRipple={disableRipple}
                {...props}
                sx={{
                    '& .PrivateSwitchBase-input ': {
                        bgcolor: 'transparent',
                        opacity: 0
                    },
                    '& .MuiSvgIcon-root': {
                        fontSize: 38,
                        [theme.breakpoints.down('lg')]: {
                            fontSize: 29
                        },
                        [theme.breakpoints.up('lg')]: {
                            fontSize: 32
                        },
                        [theme.breakpoints.up('xl')]: {
                            fontSize: 40
                        }
                    },
                    [theme.breakpoints.down('lg')]: {
                        width: '23px',
                        height: '23px'
                    },
                    [theme.breakpoints.up('lg')]: {
                        width: '26px',
                        height: '24px'
                    },
                    [theme.breakpoints.up('xl')]: {
                        width: '32px',
                        height: '29px'
                    }
                }}
                checkedIcon={
                    <svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.1" y="0.6" width="28.8" height="28.8" rx="2.9" fill="#02836F" />
                        <rect x="0.1" y="0.6" width="28.8" height="28.8" rx="2.9" stroke="black" strokeWidth="0.2" />
                        <path
                            d="M6.5 16.5L11.9501 22.5126C12.1722 22.7576 12.5666 22.7234 12.7432 22.4438L22.5 7"
                            stroke="white"
                            strokeWidth="3"
                            strokeLinecap="round"
                        />
                    </svg>
                }
                icon={
                    <svg
                        width="29"
                        height="29"
                        viewBox="0 0 29 29"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="rounded-[3px]"
                    >
                        <rect
                            x="0.1"
                            y="0.1"
                            width="28.8"
                            height="28.8"
                            rx="3"
                            ry="3"
                            fill="white"
                            stroke={error ? 'red' : uncheckedStrokeColor}
                            strokeWidth="2"
                        />
                    </svg>
                }
            />
            {label && typeof label === 'string' ? <span data-testid={`${testId}-label`} className={`text-lg text-dark lg:text-22 ${labelClassName}`}>{label}</span> : label}
        </div>
    );
};

export default Checkbox;
